import './css/App.css';

import { useTransition, animated } from 'react-spring';

const Home = () => {

    const transition = useTransition(1, {
        from: {x:-100, y:1000, opacity: 0 },
        enter: item=>async(next) =>{
            await next({x:-100, y:0, opacity: 1, delay: 200 })
            await next({x:0})
        },
        leave: {},
    });

    return (
        <div className="Home">
            <div className='image'>
                <img src="https://res.cloudinary.com/dke9xzbl6/image/upload/v1640509076/portfolio-content/home_face_sdrokn.png" alt="errorloading" className='image_face'></img>
            </div>
            <h1 className='main'>
                {
                    transition((style, items) =>
                        items ? <animated.div style={style}>
                            HELLO, I AM AMREET<br />
                            A DESIGNER,<br></br>
                            FRONT-END DEVELOPER,<br></br>
                            MUSICIAN, GAMER<br></br>
                            AND THE LIST GOES ON<br></br>
                        </animated.div> : ""
                    )
                }
            </h1>
        </div>
    );
}

export default Home;